export enum SortMethodsEnum {
  DEFAULT = 'Default',
  CUSTOM = 'Custom'
}
